import React from "react";
import { Link, useHref, useLocation, useParams, useSearchParams } from "react-router-dom";
import Panel from "../../components/Panel/Panel";
import styles from "./payment-success.scss";

export default function PaymentDone() {
    let [searchParams] = useSearchParams();
    let [status] = React.useState(searchParams.get("status"));
    let paymentLink = "/pay/" + searchParams.get("page");
    let title = (status !== "bad" ? "Всё прошло успешно." : "Что-то пошло не так.");
    let description = (status !== "bad" ? 
        "Мы свяжемся с вами, если понадобится уточнить некоторую информацию."
        :
        <span>Не удалось завершить оплату. Вернитесь на страницу оплаты и <Link to={paymentLink}>повторите платёж</Link>.</span>
    ) ;
    return (
        <Panel contentStyles={{background: "#F4F4F6", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}}  fill={true}>
            <div className={styles.wrapper}>
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.description}>{description}</p>
            </div>
        </Panel>
    )
}